import React from "react";
import { Image } from "react-bootstrap";
import { CgRemove } from "react-icons/cg";

const FilesPreviewComponent = React.forwardRef((props, ref) => {
  const { files, setFiles } = props;

  const removeImage = (id) => {
    const updatedFiles = files.filter((file) => file.id !== id);
    setFiles(updatedFiles);
    ref.current.value = null;
  };

  return (
    <div className="image-preview mx-3 custome-sidebar rounded-4">
      <div className="d-flex align-items-center ">
        {files?.map((f) => (
          <div
            className="d-flex align-items-start mb-1 position-relative me-1 bg-white rounded-4"
            key={f.id}
            data-testid="uploaded-image"
          >
            <Image
              src={f.attachment}
              width={80}
              height={80}
              alt="Img"
              className="rounded-4 border border-dark shadow"
            />
            <CgRemove
              size={20}
              role="button"
              title="remove-image"
              className="delete-image-icon"
              onClick={() => removeImage(f.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default React.memo(FilesPreviewComponent);
